import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';

/** Shown instead of a map whose scripts are blocked (ad-blockers, corporate proxies) or that failed inside (RD-2824). */
const MapUnavailable: React.FC = () => {
  const { tr } = useTranslationLgs();

  return (
    <div className="flex min-h-[200px] items-center justify-center rounded-lg bg-base-quaternary p-6 text-center text-sm text-content-secondary">
      {tr(`HereMaps.mapUnavailable`, `Mapu se nepodařilo načíst. Zkontrolujte prosím blokování skriptů v prohlížeči nebo firemní síti.`)}
    </div>
  );
};

export default MapUnavailable;
